import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import explorerEn from "./locales/en/explorer.json";
import explorerPt from "./locales/pt/explorer.json";
import explorerEs from "./locales/es/explorer.json";
import radarEn from "./locales/en/radar.json";
import radarPt from "./locales/pt/radar.json";
import radarEs from "./locales/es/radar.json";
import { DEFAULT_LANG } from "shared/constants/LocalStorageConsts";

// const en = { ...explorerEn, ...radarEn };
// const pt = { ...radarPt, ...explorerPt };
const getBrowserLanguage = () => {
  try {
    const supportedLanguages = ["es", "en", "pt"];
    const navigatorLanguage = navigator.language;
    const lng = navigatorLanguage?.substring(0, 2);
    if (supportedLanguages.find((x) => lng === x)) {
      return lng;
    } else {
      return null;
    }
  } catch {
    return null;
  }
};

const browserLang = getBrowserLanguage();

const resources = {
  en: {
    explorer: explorerEn,
    radar: radarEn,
  },
  pt: {
    explorer: explorerPt,
    radar: radarPt,
  },
  es: {
    explorer: explorerEs,
    radar: radarEs,
  },
};
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    ns: ["explorer", "radar"],
    defaultNS: "explorer",
    lng: browserLang ?? DEFAULT_LANG,
    resources,
    debug: false,
  });

export default i18n;
